<template>
  <div :class="[`${pageClass}`]" v-loading="paperLoading">
    <!-- 试卷列表 -->
    <div class="item" v-for="(paper, index) in paperData" :key="index">
      <h3>{{ paper.pname }}</h3>
      <p>考试时间：{{ paper.duration }}分钟 <span style="margin-left: 40px">共{{ paper.userLastTestInfo.questionCount }}题</span></p>
      <div class="paperstatus">
        <span class="ok" v-if="paper.userLastTestInfo.auditStatus &&paper.userLastTestInfo.havDo">已测评</span>
        <span class="no" v-else>未测评</span>
      </div>
      <button class="button" :class="{active:!paper.userLastTestInfo.auditStatus || !paper.userLastTestInfo.havDo}" @click="toDetail(paper.userLastTestInfo.completeStatus, paper.userLastTestInfo.auditStatus, paper.userLastTestInfo.havDo, paper.synthesize, paper.id, paper.subjectId)">查看报告</button>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%">
      <span>{{ title }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisibleShow"
      width="30%">
      <span>本套试卷还未测评过，因此没有报告，是否开始测评？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleShow = false">取 消</el-button>
        <el-button type="primary" @click="startEvaluation">开始测评</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { resource } from "../../mixins/my_personal";

export default {
  name: "select_subject",
  mixins: [resource],
  data() {
    return {
      dialogVisibleShow: false,
      itemInfo: {
        code: 0,
        paperId: 0
      },
      title: '',
      dialogVisible: false,
      pageClass: "report",
      paperLoading: true,
      paperData: [],
      params: {
        // 筛选条件
        orderBy: "3",
        rule: 1,
        subjectId: null,
        appId: 100,
        dateType: null,
        pageIndex: 1,
        pageSize: 100,
      },
      // totalCount: 0, // 总页数
      activeInfo: {
        subjectList: []
      },
    }
  },
  methods: {
    startEvaluation () {
      this.dialogVisibleShow = false
      let data = {
          code: 9,
          data: `id=${this.itemInfo.code}&paper_id=${this.itemInfo.paperId}`
        }
      let info = JSON.stringify(data)
      try {
        cefJS.sendmsg(info);
      } catch (error) {
        console.log(error)
      }
    },
    toDetail (completeStatus, auditStatus, havDo, synthesize, paperId, sid) {
      this.itemInfo.code = sid
      this.itemInfo.paperId = paperId
      // if (!havDo || completeStatus && auditStatus) {
      //   this.dialogVisibleShow = true
      //   // this.title = '你还未做本专家测评卷，请在‘专家测评’中作答后，再查看报告！'
      //   // this.dialogVisible = true
      // } else {
      //   this.title = '你还有未完成的测评卷，请在‘我的学习’中继续做答提交后，再查看报告！'
      //   this.dialogVisible = true
      // }

      if (havDo && auditStatus){
        this.$router.push({
          path: '/report_detail',
          query: {
            paper_type: synthesize,
            paper_id: paperId
          }
        })
      } else {
        // this.dialogVisibleShow = true
      }
    },
    // 获取数据
    getPaperList() {
      this.loading = true;
      this.$HTTP
        .executePost(this.$APIS.GET_PAPER_PARAM, this.params, this)
        .then((res) => {
          this.loading = false;
          if (res.code == 0) {
            this.paperData = res.data.list;
            this.paperLoading = false
          } else {
            this.paperLoading = false
          }
        });
    },
  },
  created() {
     // 兼容客户端
    try {
      CefSharp.BindObjectAsync("cefJS");
    } catch (error) {
      console.log(error)
    }
    this.getPaperList();
    this.params.subjectId = this.$route.query.id || 10
  }
};
</script>
<style lang="scss" scoped>
.report {
  width: 100%;
  height: 100%;
  background: #efefef;
  overflow: scroll;
  .item {
    height: 120px;
    margin-right: 10px;
    border-radius: 8px;
    background: #fff;
    margin-bottom: 10px;
    position: relative;
    h3 {
      font-size: 21px;
      height: 21px;
      padding-top: 32px;
      color: #585858;
      padding-left: 40px;
    }
    p {
      font-size: 19px;
      line-height: 67px;
      padding-left: 40px;
      padding-top: 24px;
      color: #aaaaaa;
    }

    .button {
      position: absolute;
      width: 100px;
      height: 34px;
      font-size: 16px;
      border-radius: 17px;
      background: #00adff;
      color: #fff;
      right: 60px;
      top: 45px;
      outline: none;
      border: none;
      cursor: pointer;
      &.active{
        background: #999;
        cursor: not-allowed;
      }
    }

    .paperstatus{
      position: absolute;
      width: 80px;
      height: 34px;
      line-height: 34px;
      font-size: 16px;
      border-radius: 17px;
      color: red;
      right: 180px;
      top: 45px;
      span.ok{
        color: green;
      }
    }
  }
}
</style>
